module.exports = __webpack_public_path__ + "img/timer.0b5ca930.svg";